import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { campaignsReducers } from "./campaigns";
import { moduleName } from "./common";
/*
 * Export const reducers = combineReducers({
 *     campaigns: campaignsReducers
 * })
 */
export const reducers = campaignsReducers;
export { moduleName } from "./common";
export { apiReducers, apiReducersPath, apiMiddleware, defineTokenGetter } from "./api";
export const useCampaignsSelector = useSelector;
export const campaignDataSelector = createSelector((state) => state[moduleName], (x) => x);
